var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 260 173",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.8848 .644996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.1152 9.635004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.7231 16.8057c-.908 22.139-11.485 28.239-11.485 28.239-12.059 6.664-29.4 5.74-29.4 5.74 21.366 3.837 24.577 14.693 24.577 14.693 8.157 13.749-1.149 36.275-1.149 36.275 13.018-15.883 16.538-33.979 16.538-33.979 6.687-26.169.919-50.968.919-50.968",
    fill: "#82be42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.2702 29.725c-3.821 0-6.918 3.097-6.918 6.917 0 3.821 3.097 6.918 6.918 6.918s6.918-3.097 6.918-6.918c0-3.82-3.097-6.917-6.918-6.917",
    fill: "#82be42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.5945 50.7847s-15.768.924-26.733-5.74c0 0-9.617-6.1-10.443-28.239 0 0-5.244 24.799.836 50.968 0 0 3.2 18.096 15.037 33.979 0 0-8.461-22.526-1.044-36.274 0 0 2.919-10.856 22.347-14.694",
    fill: "#5a67d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.0522 29.725c-3.821 0-6.918 3.097-6.918 6.917 0 3.821 3.097 6.918 6.918 6.918s6.918-3.097 6.918-6.918c0-3.82-3.097-6.917-6.918-6.917",
    fill: "#5a67d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.5937 27.1583h-3.635v9.809s7.718 10.612 4.438 31.707c-3.281 21.094-23.655 39.349-49.366 40.536 0 0 27.993 5.138 48.162-21.673 20.169-26.812 4.036-57.373.401-60.379",
    fill: "#82be42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.0912 5.2858c-13.964-3.606-26.89 0-26.89 0-27.887 8.056-34.516 29.273-34.516 29.273 2.156-4.839 14.449-21.282 36.924-24.482 22.474-3.2 36.924 9.212 36.924 9.212h6.474v-4.797c-6.804-5.782-18.916-9.206-18.916-9.206",
    fill: "#82be42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.0624 112.8148s-33.444 3.272-51.622-29.79c0 0-12.878-21.425-2.037-48.047 0 0 11.759-30.846 49.781-34.407 0 0-30.536-3.25-50.858 24.145 0 0-20.917 25.385-6.346 59.608 0 0 13.29 35.417 56.947 35.326175 0 0 39.823-.947175 53.001-38.548175 0 0-11.978 29.531-48.866 31.713",
    fill: "#5a67d8"
  })), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#5a67d8",
    fontSize: 42.7179
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 154.6845,
    y: 39
  }, "+")), /*#__PURE__*/React.createElement("text", {
    fill: "#30312f",
    fontSize: 42.2449
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 162.06453
  }, "Support")), /*#__PURE__*/React.createElement("text", {
    fill: "#30312f",
    fontSize: 42.2449
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 164.58613,
    y: 161.98004
  }, "Prim"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ebe723a80b6986809dbcddf0f4d4037.svg";
export { ForwardRef as ReactComponent };